module.exports = __webpack_public_path__ + "img/projectManagementChose.svg.ca3833c4.svg";